export default __webpack_public_path__ + "static/mobile_sek2_KV05-e66dad53a8f2a1c4fd984dc5e67110bf.mp4";